export default "__VITE_ASSET__2fe148e6__"